import { Framework, UiLibraryProps, getUiLibraryProps } from '@u1/ui-library-mapper';

export const getAttributeSelector = (componentName: string) => (subComponentName: string) =>
  `[${componentName}="${subComponentName}"]`;

export const getUiProps = (el: HTMLElement, refId?: any): UiLibraryProps | null => {
  return getUiLibraryProps(el, Framework.REACT, refId);
};
